import { render, staticRenderFns } from "./h5VersionRecord.vue?vue&type=template&id=4b73cfae&"
import script from "./h5VersionRecord.vue?vue&type=script&lang=js&"
export * from "./h5VersionRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b73cfae')) {
      api.createRecord('4b73cfae', component.options)
    } else {
      api.reload('4b73cfae', component.options)
    }
    module.hot.accept("./h5VersionRecord.vue?vue&type=template&id=4b73cfae&", function () {
      api.rerender('4b73cfae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/h5VersionRecord.vue"
export default component.exports